import api from '@/api/api'
import router from '@/router/index'

export default {
  namespaced: true,
  state: {
    obj: {}
  },
  mutations: {
    set (state, payload) {
      state.obj = Object.assign({}, payload)
    }
  },
  actions: {
    comprobarScoring ({ commit, dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/scoring/comprobar_scoring', {
          jsondata: JSON.stringify({
            parametros: {
              codigoPromocion: obj.codigoPromocion,
              codigoActivo: obj.codigoActivo,
              compradores: obj.compradores,
              numOportunidad: obj.numOportunidad
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              // guardamos el objeto que nos devuelve back
              commit('set', response.data.result.data.data)
              // hacemos un resolve con el resultado para notificar a front
              resolve(response.data.result.data.data.scoringValido)
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    modificarTasaScoring ({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api.post('/scoring/modificar_tasa_scoring', {
          jsondata: JSON.stringify({
            parametros: {
              codigoPromocion: obj.codigoPromocion,
              porcentaje: obj.porcentaje
            }
          })
        })
          .then(response => {
            if (response.data.result.ok) {
              resolve()
            } else {
              switch (response.data.result.code) {
                case 1:
                  dispatch('alerts/addNotLoggedIn', null, { root: true })
                  router.push({ name: 'login' })
                  break
              }
              reject(response.data.result)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    }
  },
  getters: {
    get (state) {
      return state.obj
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/scoring/store.js